import { Component, ReactNode } from 'react';
import clsx from 'clsx';

import { IconNames } from '@shipengine/giger-theme';
import { Icon, IconSize } from '@shipengine/giger';

export enum NotificationType {
    INFO = 'INFO',
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
}

interface INotificationProps {
    type: NotificationType;
    inline: boolean;
    children: ReactNode;
    size: IconSize;
}

const defaultProps = {
    inline: false,
    type: NotificationType.INFO,
    size: IconSize.SIZE_SMALL,
};

export class Notification extends Component<INotificationProps> {
    static defaultProps: Partial<INotificationProps> = defaultProps;

    getIconName = (type: NotificationType): IconNames => {
        switch (type) {
            case NotificationType.INFO:
                return IconNames.INFO;
            case NotificationType.SUCCESS:
                return IconNames.CHECK;
            case NotificationType.ERROR:
                return IconNames.ALERT;
        }
    };

    render(): JSX.Element {
        const { children, type, inline, size } = this.props;
        const className = clsx({
            notification: true,
            [`notification--${type.toLowerCase()}`]: type,
            'notification--inline': inline,
        });

        return (
            <div className={className}>
                <div className="notification__icon">
                    <Icon name={this.getIconName(type)} size={size} />
                </div>
                <div className="notification__content">
                    <div className="notification__message">{children}</div>
                </div>
            </div>
        );
    }
}
